import { getUser } from "./auth";

export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getHeaders = () => {
  const user = getUser();
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${user?.token}`,
  };
};
